export default {
  line: "切換線路",
  language: "選擇語言",
  common: [
    "在線客服",
    "取消懸浮",
    "機器人",
    "自動視頻",
    "開始",
    "今天剩余視頻數",
    "設置自動視頻數",
    "高級版會員才可使用,請升級",
    "請設置自動視頻數"
  ],
  upload: [
    "上傳中...",
    "錯誤格式",
    "上傳成功",
    "上傳失敗"
  ],
  appMsg: [
    "準備下載更新...",
    "下載完成，是否安裝更新包",
    "下載更新失敗",
    "已下載{num}%",
    "正在更新...",
    "更新成功，即將重啟",
    "更新失敗",
    "再按一次退出應用"
  ],
  vanPull: [
    "沒有更多數據了",
    "沒有數據"
  ],
  login: {
    text: [
      "記住密碼",
      "正在登錄...",
      "立即登錄",
      "忘記密碼",
      "手機登錄",
      "郵箱登錄"
    ],
    placeholder: [
      "請輸入手機號",
      "請輸入登錄密碼",
      "請輸入郵箱地址"
    ],
    i18n: [
      "無{title}賬號?",
      "註冊"
    ]
  },
  register: {
    text: [
      "歡迎註冊",
      "短信碼發送中...",
      "獲取短信碼",
      "正在註冊...",
      "立即註冊",
      "已有賬號，馬上下載",
      "手機註冊",
      "郵箱註冊",
      "獲取驗證碼",
      "短信驗證碼",
      "郵箱驗證碼",
      "重發驗證碼"
    ],
    placeholder: [
      "請輸入手機號",
      "請輸入短信驗證碼",
      "請輸入登錄密碼",
      "請確認您的密碼",
      "請輸入邀請碼",
      "兩次密碼不一樣",
      "請輸入驗證碼"
    ],
    i18n: [
      "已有賬號?",
      "登錄"
    ],
    tips: "註冊教程"
  },
  footer: [
    "首頁",
    "視頻",
    "密聊",
    "客服",
    "我的",
    "收益",
    "眾籌",
    "動態",
    "活動"
  ],
  home: {
    broadcast: "Congratulations to the member {member} for recommending a {grade} to get {currency}{reward} promotion rewards!",
    menu: [
      "VIP專區",
      "視頻教程",
      "推廣獎勵",
      "合作媒體",
      "公司實力",
      "賬戶保險"
    ],
    taskHall: {
      title: [
        "視頻大廳",
        "商家發布大廳"
      ]
    },
    memberList: {
      title: "會員榜單",
      data: [
        "祝賀 {member}",
        "今日觀看{num}次視頻,賺取{currency}{profit}!"
      ]
    },
    businessList: {
      title: "商家榜單",
      data: [
        "{member}",
        "今天發布{num}單視頻"
      ]
    },
    noticeTitle: "最新公告",
    msg: "視頻未開放",
    video: "暫無視頻教程",
    title: ["公司簡介","會員等級"]
  },
  postTask: {
    navBar: {
      title: "發布視頻",
      right: "發布規則"
    },
    field: [{
        label: "視頻分類",
      },
      {
        label: "視頻標題",
        placeholder: "請輸入視頻標題",
        error: "視頻標題不能為空"
      },
      {
        label: "視頻簡介",
        placeholder: "請輸入視頻簡介"
      },
      {
        label: "視頻單價",
        placeholder: "請輸入視頻單價",
        error: "視頻單價不能為空"
      },
      {
        label: "領取數量",
        placeholder: "請輸入領取數量",
        error: "領取數量不能為空"
      },
      {
        label: "領取次數",
        placeholder: "請輸入領取次數",
        right: "次/人",
        error: "領取次數不能為空"
      },
      {
        label: "視頻總價",
        error: "視頻總價未計算"
      },
      {
        label: "鏈接信息",
        placeholder: "請輸入鏈接地址",
        error: "鏈接信息不能為空"
      },
      {
        label: "視頻級別",
      },
      {
        label: "截止日期",
        placeholder: "點擊選擇日期",
        error: "截止日期不能為空"
      },
      {
        label: "完成條件",
        error: "請選擇完成條件"
      },
      {
        label: "上傳要求",
        placeholder: "請輸入上傳要求",
      },
      {
        label: "審核樣例",
      },
      {
        label: "操作步驟",
        placeholder: "簡單易懂的步驟有助於完成!",
        error: "操作步驟不能為空",
        img: "有步驟圖未完善"
      },
    ],
    button: "提交",
    step: {
      title: "操作步驟",
      left: "取消",
      right: "完成",
      placeholder: "請輸入步驟描述",
      button: [
        "刪除",
        "添加"
      ]
    },
    tips: [
      "平臺手續費約 {pump}{br}本次發布需支付約 {price}，請保證賬戶余額充足 {a}{br}提示: 本平臺禁止發布黃賭毒及涉政等一切法律所禁止的內容，如發現扣除積分，封禁賬號。",
      "去充值",
      "最少保留一項步驟",
      "最多添加十個步驟"
    ]
  },
  vip: {
    user: {
      title: [
        "當前等級",
        "遊客"
      ],
      label: "每日視頻",
      value: [
        "有效期",
        "永久有效",
        "請先登錄",
        "天",
        "到期時間"
      ],
    },
    list: {
      label: "每日視頻<b>{number}</b>次",
      button: [
        "立即激活",
        "立即續費"
      ],
      text: [
        "每日收益",
        "月收益",
        "推薦獎勵:每名",
        "免費",
        "每單"
      ]
    },
    dialog: [
      "確定花費 {currency} {amount} 成為{name}嗎？",
      "你當前為{currname}，無法成為{name}",
      "確定花費 {currency} {amount} 續費{name}嗎？"
    ],
    more: "查看更多",
    top:[
      "升級所需",
      "購買返佣",
      ["1級","2級","3級"],
      ["價格","詳情"],
      "已過期"
    ]
  },
  user: {
    title: [
      "我的視頻",
      "個人記錄"
    ],
    default: [
      "我的",
      "登錄賬號",
      "邀請碼",
      "退出登錄",
      "余額",
      "金幣",
      "我的錢包",
      "封號",
      "限製",
      "良好",
      "優秀",
      "我的上級"
    ],
    grid: [
      "個人余額",
      "昨日收益",
      "今日收益",
      "本周收益",
      "本月收益",
      "上月收益",
      "總收益",
      "今日觀看(單)",
      "今日剩余視頻(單)",
      "今日提成",
      "今日返利",
      ["今日","昨日","本周","本月"],
      ["觀看收益","推廣收益","眾籌收益"],
      ["本周註冊","本周有效註冊","總工資"],
      ["今日","昨日","三天"]
    ],
    menu: [
      "觀看記錄",
      "審核視頻",
      "發布管理",
      "個人信息",
      "賬號綁定",
      "日結報表",
      "賬變記錄",
      "邀請好友",
      "團隊報表",
      "幫助手冊",
      "信用中心",
      "APP下載"
    ]
  },
  userInfo: {
    default: [
      "個人信息",
      "頭像",
      "手機號",
      "銀行卡",
      "支付寶",
      "實名認證",
      "登錄密碼",
      "資金密碼",
      "點擊設置",
      "修改頭像",
      "修改登錄密碼",
      "修改資金密碼",
      "提交",
      "清空緩存",
      "USDT錢包",
      "推送開關",
      "我的地址"
    ],
    label: [
      "原登錄密碼",
      "新登錄密碼",
      "確認密碼",
      "原資金密碼",
      "新資金密碼",
      "確認密碼",
      "忘記資金密碼",
      "短信驗證碼",
      "驗證碼"
    ],
    placeholder: [
      "請輸入原登錄密碼",
      "請輸入新登錄密碼",
      "請確認登錄密碼",
      "請輸入原資金密碼",
      "請輸入新資金密碼",
      "請確認資金密碼"
    ]
  },
  userSet: {
    default: [
      "實名認證",
      "詳細信息",
      "綁定支付寶",
      "提交",
      "綁定USDT錢包"
    ],
    label: [
      "真實姓名",
      "QQ號",
      "支付寶賬號",
      "支付寶姓名",
      "錢包類型",
      "錢包地址",
      "詳細地址",
      "聯系人",
      "電話"
    ],
    placeholder: [
      "請輸入真實姓名(本人姓名提現所用)",
      "請輸入QQ號",
      "請輸入支付寶賬號",
      "請輸入支付寶姓名",
      "請選擇錢包類型",
      "請輸入錢包地址",
      "請輸入詳細地址",
      "請先實名認證",
      "請先綁定手機"
    ],
    tips: "溫馨提示：綁定銀行卡不可以修改，為您提款使用"
  },
  bindAccount: {
    default: [
      "綁定賬號",
      "查看教程",
      "提交"
    ],
    tabs: [
      "賬號",
      "賬號",
      "賬號"
    ],
    label: [
      "操作說明",
      "添加截圖",
      "賬號"
    ],
    placeholder: "請輸入{account}賬號"
  },
  bankCard: {
    default: [
      "綁定銀行卡",
      "立即認證",
      "正在提交...",
      "立即添加",
      "添加"
    ],
    tips: [
      "請實名認證後再來添加銀行卡",
      "您綁定銀行卡的開戶名必須與您認證的實名一致，否則將無法成功提現。"
    ],
    label: [
      "姓名",
      "銀行名稱",
      "銀行帳戶",
      "IFSC代碼"
    ],
    placeholder: [
      "請選擇銀行名稱",
      "請輸入銀行帳戶",
      "請輸入IFSC代碼"
    ]
  },
  wallet: {
    default: [
      "我的錢包",
      "充值",
      "提現",
      "充值記錄",
      "提現記錄",
      "充",
      "提",
      "支付寶"
    ],
    label: [
      "提現方式",
      "提現金額",
      "資金密碼",
      "提交",
      "手機號",
      "郵箱",
      "IFSC"
    ],
    placeholder: [
      "選擇提現方式",
      "請輸入提現金額",
      "請輸入資金密碼",
      "請選擇提現方式",
      "請輸入收款人手機號",
      "請輸入收款人郵箱",
      "請輸入收款人IFSC"
    ],
    msg: [
      "你還未設置資金密碼，請先設置",
      "你還未綁定銀行卡，請先綁定"
    ]
  },
  recharge: {
    default: [
      "充值",
      "充值詳情",
      "充值記錄",
      "可用余額{money}，請選擇充值方式",
      "單筆最低金額為{currency}{min}，最高{currency}{max}，手續費{fee}%",
      "正在提交...",
      "立即充值",
      "返回",
      "加載中..."
    ],
    label: [
      "充值金額",
      "充值通道",
      "轉賬姓名",
      "付款人姓名",
      "付款人手機",
      "付款人UPI賬戶",
      "付款人郵箱"
    ],
    placeholder: [
      "請輸入充值金額",
      "請選擇充值通道",
      "請輸入轉賬姓名",
      "單筆最低金額為{currency}{min}",
      "單筆最高金額為{currency}{max}",
      "請輸入付款人姓名",
      "請輸入付款人手機號，號碼前加上國際區號，例如+86",
      "請輸入付款人UPI賬戶",
      "請輸入付款人郵箱"
    ],
    info: [
      "充值金額",
      "訂單號",
      "收款銀行",
      "收款賬號",
      "收款人",
      "復製",
      "{type} 轉賬",
      "轉賬截圖",
      "提交",
      "IFSC代碼",
      "UPI",
      "處理說明",
      "錢包地址",
      "收款二維碼",
    ],
    tips: [
      "請選擇以下方式轉賬相符的金額以免延誤財務查收<br>轉賬後請上傳轉賬截圖作為核對證明",
      "請掃描二維碼轉賬您的充值金額",
      "請按照下面信息完成轉賬",
      "提示：成功支付後，請聯系在線客服，提供您的會員賬號、充值金額、訂單號、存款人帳號、充值時間；方便財務及時為您添加資金",
      "註意：會員每筆轉賬支付請提交一次",
      "轉賬後請上傳轉賬截圖作為核對證明",
      "請選擇以下方式轉賬相符的金額",
      "請上傳轉賬截圖",
      "匯率:{price}×{rate}={currency}<b>{money}</b>,(1USDT={currency}{rate})"
    ]
  },
  task: {
    default: [
      "觀看記錄",
      "視頻要求",
      "創建",
      "審核",
      "打開鏈接",
      "復製鏈接",
      "單價",
      "提交",
      "放棄",
      "觀看時間"
    ],
    tabs: [
      "進行中",
      "審核中",
      "已完成",
      "已失敗",
      "惡意",
      "已放棄"
    ],
    msg: "請上傳完成視頻圖片",
    info: [
      "視頻詳情",
      "視頻標題",
      "視頻收益",
      "視頻描述",
      "上傳要求",
      "提交樣例",
      "用戶未提交樣例",
      "審核說明",
      "審核日期",
      "需求方",
      "發布",
      "復製",
      "跳轉",
      "視頻步驟",
      "第{index}步",
      "審核樣例",
      "無審核樣例",
      "數據加載中...",
      "放棄視頻",
      "開始觀看",
      "發布內容"
    ],
    index: [
      "當前身份",
      "您當前的等級為 <i style=\"color:#1989fa\">{currVip}</i><br>只能領取當前<i style=\"color:#1989fa\">{currVip}</i>等級的視頻<br>是否加入 <i style=\"color:#dd6161\">{vip}</i> 等級",
      "立即加入",
      "請選擇視頻類別"
    ],
    list: [
      "視頻列表",
      "需求方",
      "剩余",
      "要求",
      "領取"
    ],
    show: [
      "視頻詳情",
      "人已賺到",
      "剩余{num}個名額",
      "48小時內審核",
      "視頻描述",
      "需求方",
      "審核標準",
      "復製",
      "跳轉",
      "視頻步驟",
      "第{index}步",
      "審核樣例",
      "無審核樣例",
      "數據加載中...",
      "正在提交...",
      "領取視頻",
      "立即登錄",
      "發布內容"
    ]
  },
  audit: {
    default: [
      "審核視頻",
      "領取用戶",
      "領取日期",
      "更新日期",
      "審核",
    ],
    tabs: [
      "進行中",
      "審核中",
      "已完成",
      "已失敗"
    ],
    info: [
      "審核詳情",
      "視頻標題",
      "視頻金額",
      "人已完成",
      "剩余{num}個名額",
      "視頻描述",
      "鏈接信息",
      "審核樣例",
      "領取用戶",
      "領取",
      "完成狀態",
      "提交樣例",
      "用戶未提交樣例",
      "更新日期",
      "數據加載中...",
      "惡意",
      "重審",
      "失敗",
      "成功",
      "審核視頻",
      "審核說明",
      "請輸入審核說明",
      "提交的視頻不合格，需重新提交審核",
      "祝賀視頻完成，再接再厲",
      "提交的視頻頁面截圖錯誤，視頻失敗",
      "惡意提交視頻，視頻失敗"
    ]
  },
  postRecord: [
    "發布管理",
    "發布",
    "總量",
    "已完成",
    "截止日期",
    "審核",
    "撤銷",
    "編輯"
  ],
  dayReport: [
    "日結報表",
    "總收益",
    "我完成的視頻",
    "我的視頻收益",
    "下級完成的視頻",
    "下級視頻收益",
    "單",
    "最近30天",
    "數量",
    "視頻",
    "下級",
    "消費",
    "日期"
  ],
  fundRecord: {
    default: [
      "支出記錄",
      "充值記錄",
      "收入記錄",
      "充",
      "收",
      "支"
    ],
    tabs: [
      "收入",
      "支出",
      "充值"
    ]
  },
  promote: [
    ["每邀請{num}位有效用戶","賺","現金"],
    "可直接提現",
    "每邀請{num}位有效用戶",
    ["每日領獎","每人每天都可以領取"],
    ["有效用戶","每天邀請{num}位有效用戶"],
    ["邀請","領取","立即邀請"],
    "團隊員工獎",
    ["星代理","獎金","工資"],
    ["人","要求","已邀請"],
    "傭金介紹",
    ["分享","立即領取"],
    ["分享到社交平臺","分享"],
    ["充值","自己充值","充值"],
    ["礦機","購買礦機","購買"],
    ["理財","投資理財","投資"],
    ["立即分享給好友","邀請碼"],
    ["復製鏈接","復製邀請碼","二維碼","分享海報"],
    "保存圖片",
    "好友升級VIP獎勵",
    "詳情"
  ],
  teamReport: {
    default: [
      "搜索",
      "團隊余額",
      "團隊收益",
      "團隊充值",
      "團隊提現",
      "首充人數",
      "首推人數",
      "團隊人數",
      "團隊新增",
      "個",
      "我",
      "用戶",
      "充值",
      "提現",
      "返點",
      "視頻",
      "選擇年月日",
      "暫無數據",
      "充值金額",
      "充值人數",
      "推廣收益",
      "VIP總人數",
      "有效人數"
    ],
    tabs: [
      "團隊報表",
      "我的團隊"
    ],
    team: [
      "一級",
      "二級",
      "三級"
    ]
  },
  help: [
    "幫助手冊",
    "暫無內容"
  ],
  credit: [
    "信用中心",
    "信用說明",
    "信用記錄",
    "<p>1.信用積分每周評估一次</p><p>2.初始用戶信用積分:<b>60</b></p><p>3.如果檢測到用戶做視頻上傳虛假圖片一天扣除:<b>1</b>積分,扣分上限:<b>7</b>積分</p><p>4.如果未檢測到用戶使用虛假圖片增加<b>1</b>積分</p><p>5.信用積分低於<b>50</b>分將被限製提現</p><p>6.信用積分低於<b>30</b>分接視頻次數減半</p><p>7.信用積分小於等於<b>0</b>分將被封號</p>",
    "我的信用",
    "暫時沒有信用記錄"
  ],
  appDown: [
    "APP下載",
    "掃描二維碼下載APP",
    "保存二維碼",
    "保存二維碼成功",
    "保存二維碼失敗，請多試幾次或截屏保存",
    "復製",
    "Android下載",
    "IOS下載",
    "如果IOS版本無法正常下載，請卸載原版重新下載安裝。 不卸載會影響使用"
  ],
  dialog: [
    "提示",
    "確定",
    "正在提交...",
    "復製成功",
    "IOS系統版本低不支持",
    "正在註冊...",
    "數據加載中...",
    "暫未開放，敬請期待",
    "保存圖片成功",
    "保存圖片失敗<br>如不成功請多試幾次或截屏保存",
    "瀏覽器不支持，請截圖",
    "招商進行中",
    "目前沒有付款計劃"
  ],
  lineList: [
    "線路選擇",
    "當前線路",
    "線路"
  ],
  serviceCenter: [
    "客服中心",
    "Hi，專屬客服",
    "很高興為您服務",
    "自助服務",
    "在線客服",
    "充值客服",
    "Line客服",
    "聯系",
    "幫助手冊",
    "網站公告"
  ],
  theme: {
    title: "切換主題",
    black:"黑色主題",
    white: "白色主題",
    green: "墨綠主題"
  },
  Finance: [
    ["每日分紅","贈送股權","贈送期權","額外補貼","倍"],
    "立即搶購",
    "理財詳情",
    "訂單價格",
    ["百分比","天"],
    "立即報單",
    ["賬戶余額","項目單價","每日分紅","項目周期","天","購買份數","最大購買份數","預計可得收益"],
    "提交",
    "我的理財",
    ["取息","結束","詳情"],
    ["確定取出利息嗎,取出後將重新計息","確定結束此理財嗎"],
    "訂單詳情",
    ["總金額","訂單狀態","購買日期"]
  ],
  Video: [
    ["遊客","升級可享更多收益"],
    "立即升級",
    ["今日收益","每單","去提現"],
    ["今日已看視頻次數","剩余次數"],
    "開始觀看",
    "登錄觀看",
    "全屏觀看",
    "關閉",
    ["推薦您下載","免費下載"],
    "在線人數",
    "一鍵完成",
    "請先綁定手機號",
    "請先綁定電子郵箱"
  ],
  Disclaimer: [
    ["已經閱讀並同意","免責聲明"],
    ["登錄協議","不同意","同意"]
  ],
  Withdraw: [
    "可用余額{money}，請選擇提現賬戶",
    "提現賬戶",
    "請選擇提現賬戶",
    "提現金額",
    "請輸入提現金額",
    "錢包地址",
    "請輸入錢包地址",
    "資金密碼",
    "請輸入資金密碼",
    "立即提現",
    "匯率: {price}÷{rate}=<b>{money}</b>USDT,(1USDT={currency}{rate})",
    "選擇提現賬戶",
    ["添加銀行賬戶","綁定USDT錢包"],
    "實際到賬",
    "手機號",
    "請輸入手機號",
    "郵箱",
    "請輸入郵箱",
    "UPI",
    "請輸入UPI"
  ],
  Partner: [
    "眾籌等級",
    "眾籌",
    ["發起眾籌","參與眾籌","我的眾籌"],
    ["眾籌等級","請選擇眾籌等級"],
    ["眾籌份數","請選擇眾籌份數"],
    ["購買份數","請輸入購買份數"],
    "每份金額",
    "立即眾籌",
    ["進行中","已完成"],
    ["發起人","眾籌等級","眾籌份數","每份金額","已購","份","追加","利潤","參與","眾籌日期"],
    "眾籌規則",
    ["眾籌名稱","請輸入眾籌名稱"]
  ],
  Share: [
    "每日獎金",
    ["任務列表","作弊刷註冊的用戶將會被封禁","去分享"],
    ["任務步驟","每天可上傳{num}次"],
    ["提款到賬的圖片","成功分享到群聊的提款圖片","提交垃圾內容的用戶將被封號"," 審核通過之後，獎勵將發放到您的賬戶"],
    ["請選擇截圖上傳","請輸入你的{name}鏈接地址","圖片示例"],
    "提交",
    "分享",
    "分享今日收益",
    "步驟說明",
    "分享文案",
    "復製文案",
    "提交截圖或鏈接",
    "取消",
    "可得獎勵",
    "獎金"
  ],
  Community: [
    "動態",
    ["最新","提現","購買","傭金","收益"],
    ["價格","單次觀看收益","每日視頻次數"],
    "我也要升級"
  ],
  Register: [
    "請輸入電子郵箱",
    ["請輸入電子郵箱驗證碼","獲取郵箱碼","郵箱驗證碼"]
  ],
  UserInfo: [
    ["電子郵箱","點擊綁定"],
    ["綁定手機","綁定郵箱"],
    ["手機號","請輸入手機號"],
    ["電子郵箱","請輸入電子郵箱"],
    "請先綁定手機號再提現",
    "請先綁定電子郵箱再提現",
    ["Telegram認證","認證教程"]
  ],
  Bet: [
    "距離{no}期開獎",
    "等待開獎",
    "賬戶余額",
    "期",
    "期號",
    "投註內容",
    "註數",
    "金額",
    "狀態",
    "無記錄",
    "收起",
    "時間",
    "期號",
    "開獎號碼",
    "總和",
    "我要投註",
    "恭喜<em id='win_name'>{name}</em>在<i id='win_lottery'>{lottery}</i>中投註，中獎<em id='win_money'>{currency}{price}</em>",
    "我的<br>投註",
    "趨勢",
    "玩法",
    "玩法說明",
    "正在連接房間...",
    "等待開獎",
    "未中獎",
    "已中{price}",
    "已刪除",
    "已撤單",
    "已停止",
    "走水",
    "發送失敗，點擊消息重新發送",
    "該投註房間不存在",
    "是否跟註",
    "跟註",
    "您的瀏覽器不支持WebSocket協議",
    "聊天室通信失敗，正在嘗試重接",
    "溫馨提示，",
    "秒之後清屏",
    "你的瀏覽器不支持",
    "投註類型",
    "你還未登錄，請先登錄",
    "只能發送圖片",
    "賬戶余額不足{balance},不能進入該房間,請充值",
    "走勢",
    "官網",
    "盈利",
    ["投註","中獎","返點","盈利"],
    ["今日","昨日","本周","本月","總計"]
  ],
  BetView: [
    "最大賠率",
    "獎金",
    "快捷金額",
    "註",
    "輸入金額",
    "取消",
    "追號",
    "立即投註",
    "數據加載中...",
    "投註內容",
    "賠率",
    "請輸入投註金額",
    "當前期號未開放",
    "等待開獎中，不能投註",
    "本期已經封單，請投註下一期",
    "請選擇投註內容",
    "一鍵跟投",
    "期號",
    "期",
    "玩法",
    "投註內容",
    "投註金額",
    "跟單",
    "僅供VIP用戶開放"
  ],
  Coupon: [
    "優惠券",
    ["待使用", "已使用", "已過期"],
    ["代金券","有效期至","價值"],
    "轉贈",
    ["全選","請輸入轉贈用戶名","確認","取消"]
  ],
  Trend: [
    "走勢",
    ["30期","50期","100期"],
    ["單號走勢","多號走勢","大小走勢","單雙走勢","和值|形態"],
    ["百位","十位","個位","三碼","前二","後二","三碼和值"],
    ['百十個,3', '百位,2', '十位,2', '個位,2'],
    ['百十個,3', '和值', '形態,2'],
    ["大","小"],
    ["雙","單"],
    ["大","小","和","雙","單"],
    "期",
    ["期數","出現次數","最大連出","最大遺漏","平均遺漏"]
  ],
  BlindBox: [
    "獎品記錄"
  ],
  Activity: [
    "活動",
    ["全部","代理","會員","戰略合作","已結束"],
    "查看詳情"
  ]
}